import { data } from './theme'

export const useTheme = tenantsSlug => {
  return data[tenantsSlug] || data['odv']
}
